// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P3CvP","select":"styles_select__1sEBh"};